var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17861_265316)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.97205 0 0 8.97205 0 20C0 31.0271 8.97205 40 20 40C31.0271 40 40 31.0271 40 20C40 8.97205 31.0288 0 20 0ZM24.9738 20.7041H21.72C21.72 25.9027 21.72 32.3016 21.72 32.3016H16.8984C16.8984 32.3016 16.8984 25.9647 16.8984 20.7041H14.6065V16.6052H16.8984V13.9539C16.8984 12.0551 17.8007 9.08805 21.7643 9.08805L25.3371 9.10175V13.0806C25.3371 13.0806 23.166 13.0806 22.7439 13.0806C22.3218 13.0806 21.7216 13.2917 21.7216 14.1972V16.606H25.3952L24.9738 20.7041Z",
    fill: "#4867AA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17861_265316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.8e8e3336d021d5fea566bbcf2b92e2aa.svg";
export { ForwardRef as ReactComponent };